import { ReactNode } from "react";
import { ThemeProvider as NextThemesProvider } from "next-themes";

/**
 * Centralized theme provider.
 *
 * Dark mode is FULLY implemented via CSS tokens (`.dark` in index.css) and the
 * `next-themes` provider is wired here, but the UI toggle is intentionally not
 * mounted yet — the site ships light-first. To enable a user-facing switch
 * later, flip `themeConfig.enableToggle` and render `<ThemeToggle />`; no
 * component refactor is required.
 */

export const themeConfig = {
  /** Attribute strategy — matches Tailwind `darkMode: ["class"]`. */
  attribute: "class" as const,
  /** Light by default. */
  defaultTheme: "light",
  /** System preference is disabled so the brand ships light-first. */
  enableSystem: false,
  /** Master switch for exposing a user-facing toggle (kept off for now). */
  enableToggle: false,
  themes: ["light", "dark"],
} as const;

export function ThemeProvider({ children }: { children: ReactNode }) {
  return (
    <NextThemesProvider
      attribute={themeConfig.attribute}
      defaultTheme={themeConfig.defaultTheme}
      enableSystem={themeConfig.enableSystem}
      themes={[...themeConfig.themes]}
      disableTransitionOnChange
    >
      {children}
    </NextThemesProvider>
  );
}
